import React from 'react'
import { ILink, LINK_STYLE_ENUM } from '../../models'

function MenuCard({
  heading,
  text,
  imageUrl,
  link,
  linkStyle = LINK_STYLE_ENUM.TEXT,
  linkText = true,
}: {
  heading: string
  text: string
  imageUrl?: string
  link?: ILink
  linkStyle?: LINK_STYLE_ENUM
  linkText?: boolean
}) {
  const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.preventDefault()
    if (link) {
      window.open(link.Url, link.Target || '_self')
    }
  }

  return (
    <div
      className={`w-full flex flex-row gap-3 items-start
      md:flex-col md:w-48 pt-4 md:pt-0 cursor-pointer group`}
      onClick={(e) => handleClick(e)}
    >
      {imageUrl && (
        <div className="w-24 md:w-full  overflow-hidden">
          <img
            className="aspect-video  object-contain img-zoom-hover img-zoom-group-hover "
            src={imageUrl}
            alt={heading}
          />
        </div>
      )}
      <div className="flex flex-col gap-3 flex-1">
        <h5 className="text-[1.1875rem]  leading-normal">{heading}</h5>
        <p className="text-sm">{text}</p>
        {linkText && link && (
          <div className="py-[10px]">
            <a
              className={`link ${linkStyle} group-hover:border-engineering-grey-1 text-sm `}
              href={link.Url}
              target={link.Target}
            >
              {link.Name}
            </a>
          </div>
        )}
      </div>
    </div>
  )
}

export default MenuCard
